import React from 'react';
import {Form, Input, InputNumber, Select} from 'antd';

import {colours} from '../../helpers/car';

import {formItemFullWidth} from '../../assets/styles';
import {Car} from '../../types/carTypes';

interface CarSpecsFormProps {
    onSubmit: (car: Partial<Car>) => void;
    car: Partial<Car>;
}

const CarSpecsForm = ({onSubmit, car}: CarSpecsFormProps) => {
    const [form] = Form.useForm();

    React.useEffect(() => {
        if (car) {
            form.setFieldsValue(car);
        }
    }, [form, car]);

    const formatInput = (e: React.FocusEvent<HTMLInputElement>) => {
        const fieldName = e.target.name as keyof Partial<Car>;

        const trimmedValue = e.target.value.trim();

        form.setFieldValue(fieldName, trimmedValue);
    }

    return (
        <Form
            id="car-specs"
            layout="vertical"
            form={form}
            onFinish={onSubmit}
        >
            <Form.Item name="make" label="Make" rules={[{type: 'string'}]}>
                <Input
                    name="make"
                    onBlur={formatInput}
                    placeholder="eg. Toyota"
                />
            </Form.Item>
            <Form.Item name="model" label="Model" rules={[{type: 'string'}]}>
                <Input
                    name="model"
                    onBlur={formatInput}
                    placeholder="eg. Prius"
                />
            </Form.Item>
            <Form.Item name="year" label="Year" rules={[{type: 'number'}]}>
                <InputNumber
                    style={{...formItemFullWidth}}
                    name="year"
                    min={0}
                    placeholder="eg. 2021"
                />
            </Form.Item>
            <Form.Item name="colour" label="Colour" rules={[{type: 'string'}]}>
                <Select placeholder="Select colour">
                    <Select.Option key={0}>
                        Select colour
                    </Select.Option>
                    {
                        colours.map(value => (
                            <Select.Option
                                key={value}
                                value={value}
                                name="colour"
                            >
                                {value}
                            </Select.Option>
                        ))
                    }
                </Select>
            </Form.Item>
            <Form.Item name="seats" label="Seats" rules={[{type: 'number'}]}>
                <InputNumber
                    style={{...formItemFullWidth}}
                    name="seats"
                    min={0}
                    placeholder="eg. 5"
                />
            </Form.Item>
        </Form>
    );
}

export default CarSpecsForm;
